import {
  HeroSection,
  AboutAppSection,
  FeaturesSection,
  AppPreviewSection,
  HowItWorksSection,
  TrustSecuritySection,
  TestimonialsSection,
  DownloadAppSection,
  FAQSection,
} from '@/components/landing'

export default function HomePage() {
  return (
    <main>
      <HeroSection />
      <AboutAppSection />
      <FeaturesSection />
      <AppPreviewSection />
      <HowItWorksSection />
      <TrustSecuritySection />
      <TestimonialsSection />
      <DownloadAppSection />
      <FAQSection />
    </main>
  )
}
